<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          chargebacks = data?.metaData?.chargebacks || []
          totalPages = Math.ceil(data?.metaData?.total / 10)
          this.isLoading = false
        }
      "
      :searchQuery="{ page: currentPage, limit: 10 }"
      contentId="chargebacks"
      eventToListen="none"
    />
    <div
      class="flex flex-col md:flex-row w-full justify-between md:items-center gap-4 sticky top-0 pt-8 pb-4 bg-[#f4f4f5] z-[2]"
    >
      <div class="text-4xl title-color">Chargebacks</div>
    </div>
    <div class="py-2"></div>
    <div class="w-full relative" v-if="isLoading || chargebacks.length > 0">
      <div class="overflow-auto">
        <div>
          <div
            class="flex items-center justify-between p-4 gap-8 rounded-2xl text-sm uppercase"
          >
            <div class="flex items-center gap-4 w-[16rem] min-w-[16rem]">
              Détails
            </div>

            <div class="flex gap-6 w-[8rem] min-w-[8rem]">Clients</div>

            <div class="flex gap-6 w-[8rem] min-w-[8rem]">Date</div>


            <div class="flex gap-6 w-[16rem] min-w-[16rem]">Détail</div>

            <div
              class="flex items-center gap-2 w-[3rem] min-w-[3rem] justify-end pr-4"
            >
              Actions
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-4">
          <div
            v-for="(chargeback, index) in isLoading
              ? shimmerPayments
              : chargebacks"
            :key="index"
            :class="{ shimmerElement: chargeback.shimmer }"
            class="flex items-center justify-between p-4 py-2 rounded-2xl gap-8 [&>div]:relative h-[4lh]"
          >
            <div
              class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
            ></div>
            <!-- Product Info -->
            <div class="flex items-center gap-4 w-[16rem] min-w-[16rem]">
              <img
                :src="chargeback.image"
                :alt="chargeback.name"
                class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
              />
              <div class="w-[12rem]">
                <h3 class="text-lg font-bold title-color truncate">
                  {{ chargeback.price }} FCFA
                </h3>
                <p class="truncate text-sm">
                  {{ chargeback.productName }}
                  {{ chargeback.productName }}
                  {{ chargeback.productName }}
                </p>
              </div>
            </div>

            <!-- Price and Quantity -->
            <div class="w-[8rem] min-w-[8rem]">
              <div class="font-bold title-color truncate">
                {{ chargeback.customerName }}
              </div>
              <div>{{ $Countries.find(chargeback.countryCode)?.countryName }}</div>
            </div>

            <!-- Price and Quantity -->
            <div class="flex gap-6 w-[8rem] min-w-[8rem]">
              <div>
                {{
                  $Commons.timestampToDate(chargeback.createdAt, 'DD MMM YYYY, HH:mm')
                }}
              </div>
            </div>



            <div
              class="flex flex-col w-[16rem] min-w-[16rem] max-h-[4lh] overflow-hidden"
            >
              <div>
                {{ $t('transactions.detailedStatus.' + chargeback.statusMessage) }}
              </div>
            </div>

            <div
              class="flex items-center gap-2 w-[3rem] min-w-[3rem] justify-end relative pr-4"
            >
              <DropdownComponent
                :selects="[
                  {
                    name: 'Copier référence de transaction',
                    onClick() {
                      $Commons.copy(chargeback.transactionId || '-', 'Référence copiée')
                    },
                  },
                  {
                    name: 'Détials de transaction',
                    onClick() {
                      $Events.dispatchEvent(
                        'payment_details_requested',
                        chargeback,
                      )
                    },
                  },
                ]"
                hideArrow
                maxHeight="270px"
                displayKey="name"
                toLeft
                :onSelect="
                  selected => {
                    selected.onClick()
                  }
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                </svg>
              </DropdownComponent>
            </div>
          </div>
        </div>
      </div>
      <div class="py-2"></div>
      <div class="flex justify-center">
        <Pagination
          v-if="!isLoading"
          :currentPage="currentPage"
          :totalPages="totalPages"
          @pageClick="newPage => (currentPage = newPage)"
        />
      </div>
    </div>
    <div
      class="h-[55vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/refund.png" alt="" />
      </div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucun Chargeback appliqué</div>
        <div class="py-1"></div>
        <div class="text-lg">
          Vos chargebacks s'affichent ici
        </div>
        <div class="py-3"></div>
     
      </div>
    </div>
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DotLottieComponent from '@/components/utils/DotLottieComponent.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import Pagination from '@/components/utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    DotLottieComponent,
    Pagination,
  },
  data() {
    return {
      eventsIds: [],
      chargebacks: [],
      activeTab: 'home',
      isLoading: true,
      isSearching: false,
      shimmerPayments: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
      statuses: {
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
      typedSearchValue: '',
      currentPage: 1,
      totalPages: 10,
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewProduct() {
      this.$Events.dispatchEvent('new_product_adding_required')
    },
    setPageIsLoading() {
      this.isLoading = true
    },
  },
  watch: {
    currentPage() {
      this.isLoading = true
    },
  },
}
</script>
